'use client';

import { type RefObject, type PropsWithChildren } from 'react';
import { CarouselProvider } from '@packages/modules/src/Carousel/CarouselProvider';
import { CarouselWrapper } from '@packages/modules/src/Carousel/CarouselWrapper.client';
import { CarouselNav } from '@packages/modules/src/Carousel/CarouselNav.client';
import { CarouselVirtualizedList } from '@packages/modules/src/Carousel/CarouselVirtualizedList.client';
import {
  RecoCarouselLoadingList,
  type RecoCarouselLoadingListProps,
} from './RecoCarouselLoadingList.client';
import { RecoCarouselTitle } from './RecoCarouselTitle/RecoCarouselTitle';
import { INITIAL_RENDER_COUNT, VISIBLE_ITEMS_CLASS } from './visibleItems';

type RecoCarouselProps = PropsWithChildren<{
  title: string;
  preferTitle?: boolean;
  loadingState?: boolean;
  backgroundColor?: string;
  ref?: RefObject<HTMLDivElement | null>;
}> &
  Pick<RecoCarouselLoadingListProps, 'type'>;

export const RecoCarousel = ({
  children,
  title,
  preferTitle,
  loadingState = false,
  backgroundColor,
  ref,
  type = 'PRODUCT',
}: RecoCarouselProps) => (
  <div ref={ref}>
    <RecoCarouselTitle title={title} preferTitle={preferTitle} loadingState={loadingState} />
    <CarouselProvider>
      <CarouselWrapper style={{ backgroundColor }}>
        {loadingState ? (
          <RecoCarouselLoadingList type={type} className={VISIBLE_ITEMS_CLASS} />
        ) : (
          <>
            <CarouselNav />
            <CarouselVirtualizedList
              className={`scroll-px-1 p-1 ${VISIBLE_ITEMS_CLASS}`}
              initialRenderCount={INITIAL_RENDER_COUNT}
            >
              {children}
            </CarouselVirtualizedList>
          </>
        )}
      </CarouselWrapper>
    </CarouselProvider>
  </div>
);
